export class Player {
	constructor(game) {
		this.game = game;
		this.sizeScale = 0.2;
		this.spriteWidth = 529;
		this.spriteHeight = 791;
		this.width = this.spriteWidth * this.sizeScale;
		this.height = this.spriteHeight * this.sizeScale;
		this.x = 50;
		// this.yOnGraund = this.game.height - this.game.groundMargin;
		this.yOnGraund = this.game.height - this.height - this.game.groundMargin;
		this.y = this.yOnGraund;
		// this.hitboxWidth = 450 * this.sizeScale;
		// this.hitboxHeight = 700 * this.sizeScale;
		// this.hitboxX = (this.width - this.hitboxWidth) / 2 * this.sizeScale + this.x;
		// this.hitboxY = (this.height - this.hitboxHeight) / 2 * this.sizeScale + this.y + 25;
		this.img = document.getElementById('playerImg');
		this.frameX = 1;
		this.maxFrame = 2;
		this.frameY = 1;
		this.fps = 10;
		this.frameTimer = 0;
		this.framInterval = 1000 / this.fps;
		this.weight = 3;
		this.state = 'run';
		this.velocityY = 0;
		this.speed = 0;
	}

	onGround() {
		return this.y >= this.yOnGraund;
	}

	draw() {
		// eslint-disable-next-line max-len
		this.game.ctx.drawImage(
			this.img,
			this.frameX * this.spriteWidth,
			this.frameY * this.spriteHeight,
			this.spriteWidth,
			this.spriteHeight,
			this.x, this.y,
			this.width,
			this.height,
		);

		// debug hit box
		// this.game.ctx.strokeStyle = 'red';
		// this.game.ctx.strokeRect(this.x, this.y, this.width, this.height);
	}

	update(deltaTime) {
		// sprite animation
		if (this.frameTimer > this.framInterval) {
			if (this.frameX >= this.maxFrame) {
				this.frameX = 0;
			} else {
				this.frameX++;
			}

			this.frameTimer = 0;
		} else {
			this.frameTimer += deltaTime;
		}

		this.x += this.speed;
		this.y += this.velocityY;
		// this.hitboxY += this.velocityY;

		if (!this.onGround()) {
			this.velocityY += this.weight;

			// chsnge sprite state
			this.frameY = 0;
			this.maxFrame = 0;
			this.fps = 30;
		} else {
			this.velocityY = 0;
			this.state = 'run';

			// change sprite state
			this.frameY = 1;
			this.maxFrame = 1;
			this.fps = 30;
		}
	}

	jump() {
		if (this.state !== 'jump') {
			this.frameX = 0;
			this.maxFrame = 0;
			this.frameY = 0;
			this.state = 'jump';
			this.velocityY -= 40;

			this.game.sound.playJump();
		}
	}

	resize() {
		this.sizeScale = 0.2;
		this.spriteWidth = 529;
		this.spriteHeight = 791;
		this.width = this.spriteWidth * this.sizeScale;
		this.height = this.spriteHeight * this.sizeScale;
		this.yOnGraund = this.game.height - this.height - this.game.groundMargin;
		this.y = this.yOnGraund;
		this.x = 50;
	}
}
